import { EOpenedPhonesTypes } from '../../actions/openedPhones';
import { IOpenedPhones } from '../../types/openedPhones';
import { TReduxActions } from '../../types/redux';

export function openedPhonesReducer(state: IOpenedPhones = {}, action: TReduxActions): IOpenedPhones | {} {
  switch (action.type) {
    case EOpenedPhonesTypes.SetOpenedPhones:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
